import { Children, useState } from "react";
import { AddIcon, FormFieldIcon } from "allIcons";
import {
  BodyContainer,
  HeaderContainer,
  InputField,
  ListCard,
  ListIconWrapper,
  MainButton,
  PrimaryHeading,
  RightMainContainer,
} from "commonUI";
import { t } from "i18next";
import { ModulePrefixes } from "enums";

export default function FormFields() {
  const [formFields, setFormFields] = useState([
    "[Form Field Title]",
    "[Form Field Title]",
    "[Form Field Title]",
    "[Form Field Title]",
  ]);
  return (
    <>
      <RightMainContainer>
        <HeaderContainer>
          <PrimaryHeading>Form Fields</PrimaryHeading>
          <MainButton>
            <AddIcon />
            Add
          </MainButton>
        </HeaderContainer>
        <BodyContainer>
          <InputField placeholder={t("input.search.placeholder")} searchIcon={true} filter={true} />
          {Children.toArray(
            formFields.map((task, index) => {
              return (
                <ListCard
                  data={task}
                  duplicate={true}
                  secondaryData="[Field Type]"
                  edit={true}
                  link={`/${ModulePrefixes.TEMPLATE_LIBRARY}/form-fields/${index}`}
                  strictLink={true}
                  onDuplicate={(data) => {
                    setFormFields(() => [...formFields, `Copy of ${data}`]);
                  }}
                  onDelete={() => {
                    setFormFields(() =>
                      formFields.filter((item, i) => i !== index)
                    );
                  }}
                  icon={
                    <ListIconWrapper>
                      <FormFieldIcon fill="white" />
                    </ListIconWrapper>
                  }
                  deleteTitle={t("libraryTemplate.delete.title")}
                  deleteButtonText="Confirm Delete"
                  deleteMessage={t("libraryTemplate.delete.message")}
                />
              );
            })
          )}
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
